import React from "react";
import axios from "axios";
import config from "./config";
import { Base64 } from 'js-base64';

//COMMON VARIABLE OF USER DERAILS
let userId, userRole, userEmail, userToken, syncToken, streamData;

class LibraryApiCall extends React.Component {

    static async makeApiCall(type, info, apiPath, fileData='') {
        let apiResult = { success: false, APIResult: {}, expired: false };
        userId = config.account == 'faculty' ? config.faculty_id : config.studentId;
        userRole = config.account == 'faculty' ? 'instructor' : 'learner';
        userEmail = config.emailId;
        userToken = config.user_token;
        syncToken = config.sync_token;

        let formData = new FormData();
        formData.append(type, true);
        formData.append('data', Base64.encode(JSON.stringify(info)));

        let parameterData = JSON.stringify({
            source: 'app',
            uid: userId,
            email: userEmail,
            role: userRole
        });

        formData.append('tokenInputParameter', Base64.encode(parameterData));

        // if file data pass then it will add in form data input parameter
        if (fileData != ''){
            Object.values(fileData).map(file => {
                formData.append('file[]', file);
            });
        }

        await axios({
            method: "post",
            url: config.RootUrl + apiPath,
            data: formData,
            headers: {
                Accept: "application/json",
                "Content-Type": "multipart/form-data",
                "Authorization": "Basic " + userToken
            },
        }).then((response) => {
            
            let jsonResponse = {};

            if(typeof response.data == 'string' && response.data.includes('{')){
                console.log(response,"response");

                console.log(type,"api name");
                
                jsonResponse = JSON.parse(response.data);
            }else{
                jsonResponse = response.data;
            }
            
            if (jsonResponse.errorCode == "401") {
                this.generateTokenAPICall();
                apiResult.expired = true;
            }
            else if (jsonResponse.success == 'true' || jsonResponse.success) {
                apiResult.success = true;
                apiResult.APIResult = jsonResponse;
            }

        }).catch(err => console.log("Library API call error", err))

        return apiResult;
    }

    static generateTokenAPICall = (type, info) => {
        let formData = new FormData();
        formData.append('GenerateAccessToken', true);

        let parameterData = JSON.stringify({
            source: 'app',
            uid: userId,
            email: userEmail,
            role: userRole
        });

        formData.append('data', Base64.encode(parameterData));

        axios({
            method: "post",
            url: config.RootUrl + "/api/tokenmanagement.php",
            data: formData,
            headers: {
                Accept: "application/json",
                "Content-Type": "multipart/form-data"
            },
        }).then((response) => {
            let jsonResponse = response.data;
            if (jsonResponse.status == 'success') {
                function setCookie(name,value) {
                    document.cookie = name + "=" + (value || "") + "; path=/;";
                }

                config.user_token = jsonResponse.data.user_token;
                config.sync_token = jsonResponse.data.sync_token;

                setCookie('user_token', jsonResponse.data.user_token);
                setCookie('sync_token', jsonResponse.data.sync_token);
            }

        }).catch(err => console.log("Generate token api error", err))
    }

    getStreamData = () => {
        let formData = new FormData();
        formData.append("getInstituteStreamList", true);
        formData.append("iid", config.institute_id);

        axios({
            method: "post",
            url: config.RootUrl + "/api/generic_api.php",
            data: formData,
            headers: {
                Accept: "application/json",
                "Content-Type": "multipart/form-data",
            },
        }).then((response) => {
            let jsonResponse = response.data;
            streamData = jsonResponse.streamData;
        }).catch(error => {
            console.log(error);
        });
    }

}

export default LibraryApiCall;